var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProp65(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#6A6B6C;stroke-width:12.3364;stroke-miterlimit:10;}\r\n\t.st1{fill:#6A6B6C;}\r\n\t.st2{font-family:'GillSans';}\r\n\t.st3{font-size:69.7848px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.4,50.2c22,40,7.5,90.2-32.5,112.3c-40,21.9-90.2,7.4-112.2-32.6c-22.1-40-7.5-90.3,32.5-112.3 C90.1-4.4,140.4,10.1,162.4,50.2z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 30.7377 108.5241)",
    className: "st1 st2 st3"
  }, "65"), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.7,107.5c12.3-7.8,18.5-31.8,16.1-30.1c-10.3,7-20.5,0.8-28.8,5.1c-6.3,3.3-8.3,11.4-8.8,16.4 c0,0-4.7,1.1-10.1,0.9c-1.8-0.1-1.7,3.8-0.3,3.8c19,1.4,38.6-17.1,38.6-17.1s-7.7,16.3-25.9,20.3 C123.1,108.7,130.7,113.2,139.7,107.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProp65);
export default __webpack_public_path__ + "static/media/prop-65.a5958fe0269723067bd4bac3408bf2ac.svg";
export { ForwardRef as ReactComponent };